<template>
    <div class="mt-4">
        <div class="card course-calculator-card card-watermark" :style="errors.airport_id ? 'border: 2px solid red;' : '' + ` --logo-url: url(${base_url}/storage/logo.png)`">
            <Accordion value="0">
                <AccordionPanel value="0">
                    <AccordionHeader>
                        <div class="accordion-header-content">
                            <div class="d-flex align-items-start">
                                <i class="fal fa-plane-departure component-header-icon mt-0"></i>
                                <div>
                                    <h2 class="component-title">{{ tra.airport_pickup }}</h2>
                                    <p class="component-sub-title">{{ tra.airport_reception_departure }}</p>
                                    <p v-if="errors.airport_id" class="text-danger">{{ errors.airport_id[0] }}</p>
                                </div>
                            </div>
                            <div class="d-flex head-input-fields">
                                <button v-if="is_dashboard_user" @click.stop="showCustomAirportDialog = true" type="button" class="btn rounded-10 bg-secondary-color text-white custom-airport-btn py-1 ml-3">
                                    <i class="fal fa-plus"></i> {{ tra.add_custom_airport }}
                                </button>
                            </div>
                        </div>
                    </AccordionHeader>
                    <AccordionContent>
                        <div class="airports-container" style="position: relative;">
                            <!-- Loading overlay -->
                            <div v-if="isLoading" class="airports-loading-overlay">
                                <img :src="base_url + '/storage/circle-loader.gif'" alt="Loading..." class="loading-gif" />
                            </div>
                            
                            <div class="row align-items-end course-row py-2 justify-content-between">
                                <div class="col-12">
                                    <div class="d-flex align-items-start">
                                        <RadioButton class="ml-3 mt-2" v-model="airportIdValue" :value="0" />
                                        <div>
                                            <div>
                                                <h2 class="course-title">{{ tra.no_airport_transfer }}</h2>
                                                <p class="course-sub-title">{{ tra.no_need_airport_transfer }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Custom Airport Option -->
                            <div v-if="shouldShowCustomAirport"
                                class="row align-items-end course-row py-2 justify-content-between">
                                <div class="col-md-auto">
                                    <div class="d-flex align-items-start">
                                        <RadioButton class="ml-3 mt-2" v-model="airportIdValue" :value="'custom_airport'" />
                                        <div>
                                            <h2 class="course-title">{{ customAirportData.description }}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-auto" style="padding-right: 52px;">
                                    <div class="price-info d-flex align-items-end justify-content-md-end mt-2">
                                        <p class="price mb-0">
                                            {{ customAirportData.price }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div v-for="airport in airports" :key="airport.id"
                                class="row align-items-end course-row py-2 justify-content-between">
                                <div class="col-md-auto">
                                    <div class="d-flex align-items-start">
                                        <RadioButton class="ml-3" v-model="airportIdValue" :value="airport.id" />
                                        <h2 class="course-title">{{ airport.name }}</h2>
                                    </div>
                                </div>
                                <div class="col-md-auto" style="padding-right: 52px;">
                                    <div class="price-info d-flex align-items-end justify-content-md-end mt-2">
                                        <p class="price mb-0">
                                            {{ airport.formatedPrice }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>
        <!-- Custom Airport Dialog -->
        <Dialog v-model:visible="showCustomAirportDialog" :style="{ width: '450px' }" :modal="true" :closable="true">
            <div class="p-4">
                <h3 class="mb-3">{{ tra.add_custom_airport }}</h3>
                <div class="form-group mb-3">
                    <label>{{ tra.airport_description }}</label>
                    <input v-model="custom_airport.description" type="text" class="form-control"
                        :placeholder="tra.airport_description">
                </div>
                <div class="form-group mb-3">
                    <label>{{ tra.airport_price }}</label>
                    <input v-model="custom_airport.price" type="number" class="form-control">
                </div>
                <div class="d-flex justify-content-end">
                    <button @click="showCustomAirportDialog = false" type="button"
                        class="btn rounded-10 bg-secondary-color text-white ml-2">{{ tra.close }}</button>
                    <button @click="addCustomAirport" type="button"
                        class="btn rounded-10 bg-main-color text-white">{{ tra.add }}</button>
                </div>
            </div>
        </Dialog>
        </div>
    </div>
</template>

<script>
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import RadioButton from 'primevue/RadioButton';
import Tag from 'primevue/Tag';
import Dialog from 'primevue/dialog';

export default {
    components: {
        Accordion,
        AccordionPanel,
        AccordionHeader,
        AccordionContent,
        RadioButton,
        Tag,
        Dialog,
    },
    props: ['institute_id', 'base_url', 'pref_currency', 'airportId', 'start_date', 'errors', 'old', 'tra', 'customAirportData', 'is_dashboard_user'],
    emits: ['update:airportId', 'update:customAirport'],
    data() {
        return {
            airports: [],
            lang: window.current_locale,
            isInitialized: false,
            isLoading: false,
            showCustomAirportDialog: false,
            custom_airport: {
                description: '',
                price: '',
            },
        };
    },
    watch: {
        start_date(newStartDate, oldStartDate) {
            // Only refetch if component is initialized and start date actually changed
            if (this.isInitialized && newStartDate && newStartDate !== oldStartDate) {
                this.getAirports();
            }
        }
    },
    methods: {
        getAirports() {
            if (!this.institute_id) {
                return;
            }

            this.isLoading = true;

            axios.get(this.base_url + '/api/get-airports', {
                params: {
                    institute_id: this.institute_id,
                    pref_currency: this.pref_currency,
                    start_date: this.start_date,
                    lang: this.lang,
                },
            }).then((response) => {
                this.airports = response.data;
                this.isLoading = false;
            }).catch((error) => {
                console.error('Error fetching airports:', error);
                this.isLoading = false;
                if (error.response && error.response.status === 429) {
                    console.warn('Rate limit exceeded for airports. Retrying in 2 seconds...');
                    setTimeout(() => {
                        this.getAirports();
                    }, 2000);
                }
            });
        },
        addCustomAirport() {
            if (this.custom_airport.description && this.custom_airport.price) {
                this.showCustomAirportDialog = false;
                this.$emit('update:customAirport', this.custom_airport);
                this.airportIdValue = 'custom_airport';
            }
        },
    },
    computed: {
        airportIdValue: {
            get() {
                return this.airportId;
            },
            set(value) {
                this.$emit('update:airportId', value);
            }
        },
        shouldShowCustomAirport() {
            return this.customAirportData && this.customAirportData.description && this.customAirportData.price;
        },
    },
    mounted() {
        this.$nextTick(() => {
            // Set old values if they exist
            if (this.old.airport_id) {
                this.airportIdValue = Number(this.old.airport_id);
            }

            // Delay initialization to prevent immediate conflicts
            setTimeout(() => {
                this.isInitialized = true;
                this.getAirports();
            }, 500);
        });
    },
};
</script>

<style scoped>
.airports-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.loading-gif {
    width: 50px;
    height: 50px;
}

.course-calculator-card{
    min-height: 150px;
}

.custom-airport-btn {
    margin-left: auto;
    padding: 8px 16px;
    font-size: 14px;
}

.custom-airport-btn i {
    margin-right: 6px;
}
</style>